import { FreewheelParameterType } from 'tag/ts/tag/ads/freewheel/enums/FreewheelParameterType';
import { IFreewheelParameter } from 'tag/ts/tag/ads/freewheel/interfaces/IFreewheelParameter';
import { IFreewheelParameterArgument } from 'tag/ts/tag/ads/freewheel/interfaces/IFreewheelParameterArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Base class for all Freewheel parameters
 */
export abstract class AbstractFreewheelParameter implements IFreewheelParameter {
	name?: string;
	key: string;
	value: any;
	type: FreewheelParameterType;

	protected constructor( argument: IFreewheelParameterArgument ) {
		this.name = argument.name;
		this.key = argument.key;
		this.value = argument.value;
		this.type = argument.type;
	}
}